export const ADD_TO_HISTORY = "ADD_TO_HISTORY"
export const DELETE_FROM_HISTORY = "DELETE_FROM_HISTORY"
export const HISTORY_REQUEST = "HISTORY_REQUEST"
export const HISTORY_SUCCESS = "HISTORY_SUCCESS"
export const CLEAR_ALL_HISTORY = "CLEAR_ALL_HISTORY"
